import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { useSweetAlert } from '@/composables/sweetalert';
import { AnnouncementAction, AnnouncementGetter } from '@/store/announcement/announcement.module';
import { Announcement, AnnouncementAttachment } from '@/store/announcement/announcement.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'AnnouncementImageComponent',
  components: {
    BaseModalComponent,
  },
  props: {
    announcementId: {
      type: Number,
    },
  },
  setup: (props) => {
    const store = useStore();
    const swal = useSweetAlert();
    const announcement = computed<Announcement | undefined>(() => store.getters[AnnouncementGetter.BY_ID](props.announcementId));
    const images = computed<AnnouncementAttachment[]>(() => (announcement.value) ? announcement.value?.attachments.filter(m => m.attachmentType.id === 2) : []);
    const isLoading = computed(() => store.getters[AnnouncementGetter.STATUS] === 'init' || store.getters[AnnouncementGetter.STATUS] === 'loading');
    const announcementImageModal = ref<InstanceType<typeof BaseModalComponent>>();
    const fileDialog = ref<HTMLInputElement>();

    // show modal
    const show = () => {
      announcementImageModal.value?.show();
    };

    // hide modal
    const hide = () => {
      announcementImageModal.value?.hide();
    };

    // open file dialog
    const fileDialogOpen = () => {
      fileDialog.value?.click();
    };

    const fileDialogChange = () => {
      const files = fileDialog.value?.files as FileList;
      store.dispatch(AnnouncementAction.ADD_ATTACHMENT, {
        announcementId: props.announcementId,
        attachmentTypeId: 2,
        names: Array(files.length).fill('image'),
        files: files,
      });
    };

    const deleteImage = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(AnnouncementAction.REMOVE_ATTACHMENT, {
              announcementId: props.announcementId,
              attachmentIds: [id],
            });
          }
        });
    };

    return {
      announcement,
      images,
      announcementImageModal,
      fileDialog,
      isLoading,
      show,
      hide,
      fileDialogOpen,
      fileDialogChange,
      deleteImage,
    };
  }
});
